// extracted by mini-css-extract-plugin
export var cardSelected = "_i6-2";
export var image = "_i6-1";
export var table = "_i6-0";